import React from 'react';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { BrokerSsoConfigurationService } from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '@wealthlane/api-services/wealthlane-identity-service';
import ToastComponent from '../../components/toast';

const usePostBrokerSsoConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload?: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          BrokerSsoConfigurationService.putApiIdentityApiAppBrokerSsoConfiguration(id, payload)
        );
      }
      return await handleRequest(
        BrokerSsoConfigurationService.postApiIdentityApiAppBrokerSsoConfiguration(payload)
      );
    },
    {
      onSuccess: (data) => {
        if (data?.isSuccess) {
          void queryClient.invalidateQueries('getBrokerSsoConfigurationList'),
            toast.success(
              <ToastComponent
                label='Success'
                message='Brokerage SSO Configuration saved successfully.'
              />
            );
          onSuccess();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostBrokerSsoConfiguration;
